angular.module 'zc.users.pages'

.config ($stateProvider) ->

  $stateProvider
  .state 'users.pricing',
    url: '/pricing'
    views:
      'content@':
        templateUrl: '/templates/users.pages/views/pricing.html'



// WEBPACK FOOTER //
// ./src/zenclerk_modules/users.pages/routes.js.coffee